function IconSimpleStarHalf({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.2918 13L7 10.1672V1L5.58359 5.58359H1L4.7082 8.41641L3.2918 13Z" fill={fill} />
      <path d="M7 1L8.41641 5.58359H13L9.2918 8.41641L10.7082 13L7 10.1672L3.2918 13L4.7082 8.41641L1 5.58359H5.58359L7 1Z" stroke={stroke} strokeLinejoin="bevel" />
    </svg>
  )
}

export default IconSimpleStarHalf